exports.f = Object.getOwnPropertySymbols;



//////////////////
// WEBPACK FOOTER
// /produit/nodejs/bin/node-v14.19.0-linux-x64/lib/~/core-js/modules/_object-gops.js
// module id = 128
// module chunks = 0